import React from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { Box, Collapse, Tooltip } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { get } from "lodash";
import {
  DashboardIcon,
  UsersIcon,
  TargetIcon,
  CheckinIcon,
  companyIcon,
  VisionIcon,
  BarGraph,
} from "Assets/images";
import { StyledListItem } from "./../StyledListItem";
import { useStyles } from "./../styles";
import {
  DASHBOARD,
  TARGET,
  USERS,
  COMPANY_SETTINGS,
  VISION,
  REPORTS,
  USERS_LIST,
  TARGET_LIST,
  SUCCESS_STORIES,
  BOARD,
  CHECKIN,
  TEMPLATE,
  PERFORMANCE_REVIEW,
  DEPARTMENTS,
  COACHING,
  EXECUTIVE,
} from "Constants/routeConstants";
import { COMPANY_ADMIN } from "../../../constants";
import {
  CompanyDetails,
  permissionsSet,
} from "Recoil/LoggedInUserDetail/selector";
import { useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import { useMainTheme } from "Hooks/useMainTheme";
import { getCompanyId, getUserRole } from "src/utils";
import { ExpandLessRounded, ExpandMoreRounded } from "@material-ui/icons";

const LeftDrawer = ({
  isDrawerOpen = false,
  handleDrawerToggle,
  selectedIndex,
  setSelectedIndex,
  subSelectedIndex,
  getCompanyDetails,
  refreshHeader,
  setRefreshHeader,
}) => {
  const companyData = useRecoilValue(CompanyDetails);
  const permissions = useRecoilValue(permissionsSet);
  const reportsPermission =
    get(permissions, "transcriptReport.readAccess", false) ||
    get(permissions, "transcriptReport.modifyAccess", false) ||
    get(permissions, "transcriptReport.writeAccess", false) ||
    get(permissions, "transcriptReport.deleteAccess", false);
  const coachingReport =
    get(permissions, "coachingReport.readAccess", false) ||
    get(permissions, "coachingReport.modifyAccess", false) ||
    get(permissions, "coachingReport.writeAccess", false) ||
    get(permissions, "coachingReport.deleteAccess", false);
  const departmentReport =
    get(permissions, "departmentReport.readAccess", false) ||
    get(permissions, "departmentReport.modifyAccess", false) ||
    get(permissions, "departmentReport.writeAccess", false) ||
    get(permissions, "departmentReport.deleteAccess", false);
  const executiveReport =
    get(permissions, "executiveReport.readAccess", false) ||
    get(permissions, "executiveReport.modifyAccess", false) ||
    get(permissions, "executiveReport.writeAccess", false) ||
    get(permissions, "executiveReport.deleteAccess", false);
  const styleProps = useMainTheme();
  const classes = useStyles(styleProps);
  const handleListItemClick = (event, index, value, subIndex) => {
    if (value === "reportClick") {
      setRefreshHeader(!refreshHeader);
      setSelectedIndex(index);
      handleClick();
      // setSubSelectedIndex(subIndex);
    }
    setRefreshHeader(!refreshHeader);
    setSelectedIndex(index);
  };
  const { t } = useTranslation();
  const companyId = getCompanyId();
  const userRole = getUserRole();
  const checkinsPermission = get(companyData, "feature.checkin", []).filter(
    (res) => res.isEnabled
  );

  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <Drawer
      variant="permanent"
      className={clsx(classes.drawer, {
        [`${classes.drawerOpen} drawer-open`]: isDrawerOpen,
        [classes.drawerClose]: !isDrawerOpen,
      })}
      classes={{
        paper: clsx(classes.paper, {
          [classes.drawerOpen]: isDrawerOpen,
          [classes.drawerClose]: !isDrawerOpen,
        }),
      }}
    >
      <IconButton
        inputProps={{ "data-testid": "iconbtn" }}
        data-testid={"iconbtn"}
        disableRipple
        color="inherit"
        aria-label="open drawer"
        onClick={() => handleDrawerToggle(!isDrawerOpen)}
        className={`${classes.menuButton} ${
          isDrawerOpen ? classes.isOpen : ""
        }`}
      >
        <Tooltip title="Menu">
          <div className={classes.menu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </Tooltip>
        {isDrawerOpen ? (
          <span className={classes.collapseBtn}>Collapse</span>
        ) : null}
      </IconButton>

      <List
        component="nav"
        className={`${classes.navList} ${
          isDrawerOpen ? classes.navListOpen : classes.navListClose
        }`}
      >
        <StyledListItem
          button
          className={classes.menuList}
          selected={selectedIndex === 0}
          data-testid="handleListItemClick0"
          onClick={(event) => handleListItemClick(event, 0)}
        >
          <Link to={DASHBOARD} className={classes.menuItemIcon}>
            <Tooltip title={"Dashboard"}>
              <ListItemIcon>
                <img src={DashboardIcon} alt="dashboard" />
              </ListItemIcon>
            </Tooltip>

            <ListItemText
              primary="Dashboard"
              className={classes.MuiListItemText}
            ></ListItemText>
          </Link>
        </StyledListItem>
        <StyledListItem
          button
          className={classes.menuList}
          selected={selectedIndex === 5}
          data-testid="handleListItemClick5"
          onClick={(event) => handleListItemClick(event, 5)}
        >
          <Link to={`${VISION}${BOARD}`} className={classes.menuItemIcon}>
            <Tooltip title={"Visions"}>
              <ListItemIcon>
                <img src={VisionIcon} alt="vision" />
              </ListItemIcon>
            </Tooltip>
            <ListItemText
              primary="Visions"
              className={classes.MuiListItemText}
            />
          </Link>
        </StyledListItem>
        <StyledListItem
          button
          className={classes.menuList}
          selected={selectedIndex === 2}
          data-testid="handleListItemClick2"
          onClick={(event) => handleListItemClick(event, 2)}
        >
          <Link to={`${TARGET}${TARGET_LIST}`} className={classes.menuItemIcon}>
            <Tooltip title={"Targets"}>
              <ListItemIcon>
                <img src={TargetIcon} alt="target" />
              </ListItemIcon>
            </Tooltip>
            <ListItemText
              primary="Targets"
              className={classes.MuiListItemText}
            />
          </Link>
        </StyledListItem>
        {checkinsPermission?.length ? (
          <StyledListItem
            button
            className={classes.menuList}
            selected={selectedIndex === 3}
            data-testid="handleListItemClick3"
            onClick={(event) => handleListItemClick(event, 3)}
          >
            <Link to={CHECKIN + TEMPLATE} className={classes.menuItemIcon}>
              <Tooltip title={"Check-in Templates"}>
                <ListItemIcon>
                  <img src={CheckinIcon} alt="Check-in Templates" />
                </ListItemIcon>
              </Tooltip>
              <ListItemText
                primary="Check-in Templates"
                className={classes.MuiListItemText}
              />
            </Link>
          </StyledListItem>
        ) : null}
        {userRole === COMPANY_ADMIN ||
        get(getCompanyDetails, "feature.myTeam", false) ? (
          <StyledListItem
            button
            className={classes.menuList}
            selected={selectedIndex === 1}
            data-testid="handleListItemClick1"
            onClick={(event) => handleListItemClick(event, 1)}
          >
            <Link to={`${USERS}${USERS_LIST}`} className={classes.menuItemIcon}>
              <ListItemIcon>
                <Tooltip title={"People"}>
                  <img src={UsersIcon} alt="users" />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary={"People"}
                className={classes.MuiListItemText}
              />
            </Link>
          </StyledListItem>
        ) : null}
        {userRole === COMPANY_ADMIN ||
        get(permissions, "companyBrandingRules.modifyAccess", false) ||
        get(permissions, "companyBrandingRules.writeAccess", false) ? (
          <StyledListItem
            button
            className={classes.menuList}
            selected={selectedIndex === 4}
            data-testid="handleListItemClick4"
            onClick={(event) => handleListItemClick(event, 4)}
          >
            <Link
              to={`${COMPANY_SETTINGS}/${companyId}`}
              className={classes.menuItemIcon}
            >
              <ListItemIcon>
                <Tooltip title={"Organization Settings"}>
                  <img src={companyIcon} alt="company-settings" />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary="Organization Settings"
                className={classes.MuiListItemText}
              />
            </Link>
          </StyledListItem>
        ) : null}
        {reportsPermission ? (
          <StyledListItem
            button
            data-testid="handleListItemClick6"
            className={`${classes.menuList} ${classes.expandMenu}`}
            // selected={open}
            selected={Array.from(Array(5))
              .map((_, i) => i)
              .includes(subSelectedIndex)}
            onClick={() => handleClick()}
          >
            <Box className={classes.menuItemIcon}>
              <ListItemIcon>
                <Tooltip title={"Reports"}>
                  <img src={BarGraph} alt="Reports" />
                </Tooltip>
              </ListItemIcon>
              <ListItemText
                primary="Reports"
                className={classes.MuiListItemText}
              />
            </Box>
            {open ? (
              <ExpandLessRounded className={`${classes.expandIcon} mr20`} />
            ) : (
              <ExpandMoreRounded className={`${classes.expandIcon} mr20`} />
            )}
          </StyledListItem>
        ) : null}
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding className={classes.subMenu}>
            <StyledListItem
              button
              className={classes.menuList}
              selected={subSelectedIndex === 0}
              data-testid="handleListItemClick60"
              onClick={(event) =>
                handleListItemClick(event, 6, "reportClick", 0)
              }
            >
              <Link
                to={`${REPORTS}${SUCCESS_STORIES}`}
                className={classes.menuItemIcon}
              >
                <ListItemText
                  primary="Success stories"
                  className={classes.MuiListItemText}
                />
              </Link>
            </StyledListItem>
            <StyledListItem
              button
              className={classes.menuList}
              selected={subSelectedIndex === 1}
              data-testid="handleListItemClick61"
              onClick={(event) =>
                handleListItemClick(event, 6, "reportClick", 1)
              }
            >
              <Link
                to={`${REPORTS}${PERFORMANCE_REVIEW}`}
                className={classes.menuItemIcon}
              >
                <ListItemText
                  primary="Performance reviews"
                  className={classes.MuiListItemText}
                />
              </Link>
            </StyledListItem>
            {departmentReport ? (
              <StyledListItem
                button
                className={classes.menuList}
                selected={subSelectedIndex === 2}
                data-testid="handleListItemClick62"
                onClick={(event) =>
                  handleListItemClick(event, 6, "reportClick", 2)
                }
              >
                <Link
                  to={`${REPORTS}${DEPARTMENTS}`}
                  className={classes.menuItemIcon}
                >
                  <ListItemText
                    primary="Department overview"
                    className={classes.MuiListItemText}
                  />
                </Link>
              </StyledListItem>
            ) : null}
            {coachingReport ? (
              <StyledListItem
                button
                className={classes.menuList}
                selected={subSelectedIndex === 3}
                data-testid="handleListItemClick63"
                onClick={(event) =>
                  handleListItemClick(event, 6, "reportClick", 3)
                }
              >
                <Link
                  to={`${REPORTS}${COACHING}`}
                  className={classes.menuItemIcon}
                >
                  <ListItemText
                    primary="Coaching comparison"
                    className={classes.MuiListItemText}
                  />
                </Link>
              </StyledListItem>
            ) : null}
            {executiveReport ? (
              <StyledListItem
                button
                className={classes.menuList}
                selected={subSelectedIndex === 4}
                data-testid="handleListItemClick64"
                onClick={(event) =>
                  handleListItemClick(event, 6, "reportClick", 4)
                }
              >
                <Link
                  to={`${REPORTS}${EXECUTIVE}`}
                  className={classes.menuItemIcon}
                >
                  <ListItemText
                    primary="Executive snapshot"
                    className={classes.MuiListItemText}
                  />
                </Link>
              </StyledListItem>
            ) : null}
          </List>
        </Collapse>
      </List>
    </Drawer>
  );
};

export default LeftDrawer;
